<template>
  <div class="sections-holder">
    <FaqSection>
      <span slot="heading">
        How to find the coefficient of variation in Excel?
      </span>
      <div slot="content">
        <p>There is no built-in function in Excel that allows you to calculate the coefficient of variation directly. Instead, you have to use the formulas for standard deviation (STDEV.S or STDEV.P) and mean (AVERAGE).</p>
        <div v-for="(obj, i) in data" :key="i">
          <p v-if="obj.p">
            {{ obj.p }}
          </p>
          <img :class="{ 'no-top-margin': !obj.p }" :src="require(`../../../../assets/images/calculators/coefficient-of-variation/cov-0${obj.imgNum}-faq-desktop.png`)" :alt="obj.alt">
        </div>
        <p>As a result, we obtain a coefficient of variation of 0.48.</p>
        <p>You can double-check the results with the Coefficient of Variation Calculator above.</p>
      </div>
    </FaqSection>
    <hr>
    <FaqSection>
      <span slot="heading">
        What is a good coefficient of variation?
      </span>
      <div slot="content">
        <p>Whether a particular coefficient of variation is considered good or bad depends on the situation. Generally, a lower coefficient indicates greater consistency and data precision, whereas a higher coefficient signals greater dispersion and variability. For example, in chemistry or physics, a CV of less than 5% may be considered a good value. But in other fields such as economics, an acceptable value would be considered 20% or less. It all depends on the industry and specific context, in which you’re applying the analysis. In other words, it’s important to remember that there is no hard and fast rule as to what a good or bad coefficient of variation is.</p>
      </div>
    </FaqSection>
  </div>
</template>

<script>
import FaqSection from './Section.vue';

export default {
  components: {
    FaqSection,
  },
  data() {
    return {
      data: [
        {
          p: 'For example, let’s calculate the coefficient of variation in Excel for the following dataset:',
          imgNum: 1,
          alt: 'Dataset',
        },
        {
          p: 'First, we need to obtain the mean using the AVERAGE function:',
          imgNum: 2,
          alt: 'Average function in Excel.',
        },
        {
          p: 'The next step is to estimate the standard deviation. Assuming that the dataset represents a sample, we will use the STDEV.S function:',
          imgNum: 3,
          alt: 'Using STDEV.S function to find the standard deviation.',
        },
        {
          p: 'The last step is to divide the standard deviation by the mean:',
          imgNum: 4,
          alt: 'Dividing standard deviation by the mean.',
        },
        {
          p: '',
          imgNum: 5,
          alt: 'We obtain coefficient of variation of 0.48.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sections-holder {
  hr {
    margin: var(--spacing-8) 0 var(--spacing-24);
    border: 1px solid rgba(0, 12, 31, 0.12);
  }
}
</style>
